/** Presentation adapter only. The server owns relation discovery and policy;
 * never reconstruct a deletion plan from the editor's loaded working set. */
import type { DatabaseDeleteDependenciesQuery } from '@affine/graphql';

import type { ColumnInfo, DatabaseInfo } from './database-discovery';

export interface DatabaseRelationDependency {
  database: DatabaseInfo;
  columns: ColumnInfo[];
  writable: boolean;
}
export interface DatabaseDeleteDependencies {
  target: DatabaseInfo | undefined;
  dependencies: DatabaseRelationDependency[];
}
export function mapDatabaseDeleteDependencies(
  databaseBlockId: string,
  target: DatabaseInfo | undefined,
  entries: DatabaseDeleteDependenciesQuery['databaseDeleteDependencies']
): DatabaseDeleteDependencies {
  return {
    target,
    dependencies: entries.map(entry => {
      const columns = entry.columns.map(column => ({
        ...column,
        type: 'relation',
        targetDatabaseId: databaseBlockId,
      }));
      return {
        writable: entry.writable,
        columns,
        database: {
          blockId: entry.databaseId,
          docId: entry.docId,
          databaseTitle: entry.databaseTitle,
          docTitle: entry.docTitle,
          columns,
        },
      };
    }),
  };
}
